// extracted by mini-css-extract-plugin
export var hero = "hero-module--hero--JreNK";
export var container = "hero-module--container--WeT02";
export var mainTitle = "hero-module--mainTitle--RCZnU";
export var subTitle = "hero-module--subTitle--mv-dy";
export var heroImageLayer = "hero-module--heroImageLayer--uskfh";
export var downloadButton = "hero-module--downloadButton--m0rdh";
export var colorBlue = "hero-module--colorBlue--QPWId";
export var colorDarkBlue = "hero-module--colorDarkBlue--7FWK3";